export interface IKioskModel {
    kioskId: number;
    theme: string;
    language: string;
    menusData: IMenus[];
    selectedArea: number;
    loading: boolean;
    errorMessage: string;
    selectedMenu: IMenus[];
    templateData: ITemplateData;
    tokenNo: string;
    appointmentsData: IKioskAppointmentDto[],
    mrnNo: string;
    dateTime: string;
    emiratesData: any;
    isLicenseActive: number;
    kioskStartTime: string;
    kioskEndTime: string;
    kioskIdentifier: string;
    kioskType: string;
    isFeedback: number;
    menusTData: IMenusTData[]
    timer: any
    locationId: any;
    kioskRefreshTime: string,
    kioskStatus: boolean;
    menuId: number;
    departments: Idepartments[];
    doctorsData: IdoctorData[];
    selectedServiceCode: any,
    timeSchedules: any;
    searchkey: any;
    selectedDoctorId: any;
    selectedScheduleTime: string;
    inputNumber: string;
    isEnabledDobAuth: string;
    printButtondisble:boolean;
}
export interface IdoctorData {
    serviceCode: string,
    doctorslist: IdoctorList[]
}

export interface IdoctorList {
    doctorName: string
    drId: number
    isActive: number
    userName: string
}
export interface Idepartments {
    branchId: number
    branchIdentifier: string
    branchNameAr: string
    branchNameEn: string
    children: Iservices[]
    serviceLocation: string
}
export interface Iservices {
    branchId: number
    isEscalation: number
    serviceId: number
    serviceNameAr: string
    serviceNameEn: string
}
export interface IMenusTData {
    branchTypeCode: string;
    branchTypeDisplay?: string;
    branchTypeId?: number;
    branchId?: number;
    branchNameAr?: string;
    branchNameEn?: string;
}

export interface ITemplateData {
    templateOrg: string;
    templates: string[];
    mrnNo: string;
    tokenNo: string;
}

export interface IAppointments {
    appId: number;
    appName: string;
    appCode: string
}

export interface IMenus {
    menuId: number;
    menuName: string;
    menuCode: string;


}
export enum IkioskManager {
    HOME = 1,
    EMIRADESVERIFICATION = 2,
    MRNVERIFICATION = 3,
    APPOINTMENTSAREA = 4,
    TOKENAREA = 5,
    ERRORBLOCKAREA = 6,
    PATIENTJOUNEYEXPLORE = 7,
    EXISTPATIENTJOUNEYPAGE = 8,
    LOADAPPOINTMENTS = 9,
    FIRSTPASSWELCOME = 10
}

export interface IKioskAppointmentDto {
    appointmentTime: string;
    departmentName: string;
    departmentNameAr: string;
    doctorName: string;
    doctorName_ar: string;
    mrnNo: string;
    patientName: string;
    patientName_ar: string;
    serviceBookedId: number;
    encounterId: string;
}

export enum IFeedBackEnums {
    HAPPY = "HAPPY",
    NATURAL = "NATURAL",
    SAD = "SAD"
}
export enum ECheckInMode {
    KIOSKCHECKIN = 'KIOSKCHECKIN'
}

export enum EKioskType {
    GENERAL = "General",
    CUSTOM = "Custom"
}

export enum EPaymentModes {
    CASH = "Cash",
    CARD = "Card"
}
